Vue.component('conservation-status', {
	props: {
		speciesCode: {
			type: String,
			required: true,
		},
		lc: {
			type: String,
			required: true,
		},
		nt: {
			type: String,
			required: true,
		},
		vu: {
			type: String,
			required: true,
		},
		en: {
			type: String,
			required: true,
		},
		cr: {
			type: String,
			required: true,
		},
		ew: {
			type: String,
			required: true,
		},
		ex: {
			type: String,
			required: true,
		},
		ne: {
			type: String,
			required: true,
		},
		dd: {
			type: String,
			required: true,
		},
		loading: {
			type: String,
			required: true,
		},
		credit: {
			type: String,
			required: true,
		},
		apiUrl: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			loading: true,
			error: false,
			status: null,
			url: '',
		};
	},
	mounted() {
		axios
			.get(this.apiUrl.replace('{0}', this.speciesCode))
			.then((res) => {
				this.loading = false;
				// res.data is an array of conservation statuses, such as CITES and IUCN
				if (res.data.length) {
					const iucn = res.data.find((item) => {
						return item.fieldName === 'IUCN_status';
					});
					if (iucn) {
						// value has the status code
						// auxCode has the ID for the BirdLife URL
						this.status = iucn.value.replace('IUCN_', '');
						this.url = 'http://datazone.birdlife.org/species/factsheet/' + iucn.auxCode;
					} else {
						this.error = true;
					}
				} else {
					this.error = true;
				}
			})
			.catch((err) => {
				this.error = true;
			});
	},
	methods: {
		constatusClass(status) {
			return 'u-color-constatus-' + status.toLowerCase();
		},
		constatusText(status) {
			return this[status.toLowerCase()];
		},
	},
	template: `<div v-if="!error" class="u-stack-responsive u-colorReverse">
					<span v-if="loading" class="u-text-3">{{ loading }}</span>
					<a v-if="status" :href="url">
						<span class="Tooltip Tooltip--sm" data-tooltip :title="credit">
							<span class="Badge u-inline-xs" :class="constatusClass(status)">
								<span class="Badge-label">{{ status }}</span>
							</span>
							{{ constatusText(status) }}
						</span>
					</a>
				</div>`,
});
new Vue({ el: '#conservation-status' });
